<template>
  <div
    v-if="header.sortable"
    :key="header.text"
    style="white-space: nowrap"
  >
    <span
      class="custom-column column sortable header-span"
      :class="{ [header.class]: header.class, 'active': isActive }"
      @click="sortChangeHandler(header.value, !isSortDescending)"
    >
      <span class="mr-1">{{ header.text }}</span>
      <v-btn
        variant="text"
        icon
        size="x-small"
        :color="color"
        @click.stop="sortChangeHandler(header.value, !isSortDescending)"
      >
        <v-icon v-if="header.icon" size="small">
          {{ iconName }}
        </v-icon>
      </v-btn>
    </span>
  </div>
  <div
    v-else
    :key="header.text"
    :class="{ [header.class] : header.class }"
  >
    {{ header.text }}
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { IHeader } from '@/bundles/BaseTable/interfaces';

export default defineComponent({
  name: 'BaseTableHeaderMulti',

  props: {
    header: {
      type: Object as PropType<IHeader>,
      required: true
    },
    color: {
      type: String as PropType<'black' | 'grey'>,
      required: true
    },
    isActive: Boolean,
    isSortDescending: Boolean
  },

  emits: ['sortChangeEvent'],

  computed: {
    sortDirection (): string {
      return this.isSortDescending ? 'descending' : 'ascending';
    },
    iconName (): string {
      switch (this.header.icon) {
        case 'date':
          return `mdi-sort-calendar-${ this.sortDirection }`;
        case 'string':
          return `mdi-sort-alphabetical-${ this.sortDirection }-variant`;
        default:
          return `mdi-sort-numeric-${ this.sortDirection }`;
      }
    }
  },

  methods: {
    sortChangeHandler (value: string, sortDesc: boolean) {
      this.$emit('sortChangeEvent', {
        sortBy: [value],
        sortDesc: [sortDesc]
      });
    },
  }
})
</script>

<style lang="scss" scoped>
.custom-column {
  &.sortable {
    &:not(.active) {
      i {
        opacity: 0;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

        &:hover {
          opacity: 1;
        }
      }
    }
    &.active {
      color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity))!important;

      i {
        opacity: 1;
      }
    }
  }
}
</style>
